import { useEffect, useState } from 'react';

export function useDebounced<V>(value: V, ms = 300): V {
  const [v, setV] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setV(value), ms);
    return () => clearTimeout(id);
  }, [value, ms]);
  return v;
}
